module.exports = "/_next/static/images/e2a8cf535b6a220878ad77748af52548-woman-with-iphone-short-form@1x.jpg";